import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './FieldTitle.css'

/**
 * Field Title is an emphasized inline title used inside choice-card style
 * [Field](/components/field/) layouts, where a [Field Label](/components/field-label/)
 * wraps a whole selectable field.
 *
 * @status draft
 * @category form
 * @lightDom true
 *
 * @slot - Default slot for the title text.
 */
@customElement('nord-field-title')
export default class FieldTitle extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-field-title': FieldTitle
  }
}
